// App.js (React)
import React, { useEffect, useMemo, useState } from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import Nav from './components/common/Nav';
import OutletLets from './components/OutletLets';
import CafePage from './components/CafePage';
import UserGallery from './components/UserGallery'
import Home from './components/Home';
import { BrowserRouter as Router, Route,Routes } from 'react-router-dom';
import CommentPage from './components/CommentPage';
import UserProfile from './components/UserProfile';
import MyProfile from './components/MyProfile'
import BlogsHome from './components/blogs/BlogsHome';
import SingleBlog from './components/blogs/SingleBlog';
import WriteBlog from './components/blogs/WriteBlog';
import BlogStats from './components/blogs/BlogStats';
import Notification from './components/common/Notification';
import MenuItems from './components/MenuItems';
import Partner from './components/Partner';
import PartnerCafeView from './components/partner/PartnerCafeView';
import OrderList from './components/OrderList';
import {io} from 'socket.io-client'
import { host } from './components/script/variables';
import OrderStatus from './components/OrderStatus';
import Contactus from './components/Contactus';
import TermsnCondition from './components/TermsnCondition';
import Cancellationandrefundpolicy from './components/Cancellationandrefpolicy';
import AddProperty from './components/partner/AddProperty';
import InvoicePage from './components/InvoicePage';
import MomentsFeed from './components/MomentsFeedV2';
import MsFeatures from './components/MsFeatures';
import AdminHome from './components/admin/AdminHome';
import ResFeedback from './components/FeedbacksRatings/ResFeedback';
import BrandStory from './components/about/BrandStory';
import RestroPilotsLoader from "./components/loader/RestroPilotsLoader";
import { Suspense } from 'react';

function App() {
  const socket = useMemo(
    () =>
      io(`${host}`,
        {
        withCredentials: true,
      }
    ),
    []
  );
  // order-status-update
  return (
    <>




      <Router>
    
        <Routes>

          {/* customer routes */}
          <Route   path='/'  Component={Home}   exact/>
          <Route   path='/moredetails' Component={CafePage}    />
          <Route   path='/cafeMedia/ug' Component={UserGallery}    />
          <Route   path='/commentpage' Component={CommentPage}    />
          <Route   path='/user' Component={UserProfile}    />
          <Route   path='/blog' Component={BlogsHome}    />
          <Route   path='/about' Component={BrandStory} />
          <Route   path='/myprofile' Component={MyProfile}    />
          <Route   path='/write' Component={WriteBlog}    />
          <Route   path='/blog/:title' Component={SingleBlog}   />
          <Route   path='/blog/stats/:authoremail' Component={BlogStats}   />
          <Route   path='/notifications' Component={Notification}    />
          <Route   path='/orderpage/:cafeid' element={<MenuItems socket={socket} />} />
<Route   path='/myorders' element={<OrderList socket={socket} />} />
          <Route   path='/orderstatus/:oid' element={<OrderStatus socket={socket} />} />
          <Route   path='/ContactUs' element={<Contactus/>} />
          <Route   path='/TermsandConditions' element={<TermsnCondition/>} />
          <Route   path='/RefundandCancellation' element={<Cancellationandrefundpolicy/>} />
          <Route   path='/invoice/:orderid' element={<InvoicePage/>} />
          <Route   path='/happymoments' element={<MomentsFeed/>} />
          <Route path = '/resfeedback' element={<ResFeedback/>}/>


          {/* partner routes */}
          <Route   path='/partner' Component={Partner}    />
          <Route   path='/partner/propertyView/:cafeid' element={<PartnerCafeView socket={socket} />} />
          <Route   path='/addproperty' element={<AddProperty/>} />
          <Route   path = '/msfeatures' element={<MsFeatures/>}/> 
          

        {/* admin routes */}
          <Route   path = '/admin' element={<AdminHome/>}/>

          

       </Routes>
      
      </Router>
      
    </>
  );
};


export default App;


